import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7e701e6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=7e701e6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e701e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e701e6a')) {
      api.createRecord('7e701e6a', component.options)
    } else {
      api.reload('7e701e6a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7e701e6a&scoped=true", function () {
      api.rerender('7e701e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appleNotifications/index.vue"
export default component.exports